import React, {useEffect, useState} from 'react'
import {getByIdResource, getResource, updateResource} from "../../service/http-service";
import {Combo} from "../../ui/Combo";
import './ProfileFormsStyle.css'
import FormHeader from '../../../assets/img/profile-images/form-header.png'

export const ProfileDrivingLicenseForm = ({entityTemp,setEntityTemp,title,updateEntity,setUpdateEntity, setAddEntity}) => {

    const [entity, setEntity] = useState()

    const [drivingLicences, setDrivingLicences] = useState([])
    const [showError, setShowError] = useState(false)


    useEffect (() => {
        setEntity(entityTemp);
        if (entityTemp.candidate) {
            getByIdResource('driving_licences/get_by_candidate', entityTemp.candidate.id).then((data) => {
                console.log(data.data)
                setDrivingLicences(data.data)
            })
        }
    }, []);




    return (

            <div className="background-form col-12 p-0">
                {(entity) && (<>
                        <img src={FormHeader} className="form-header-image"/>
                        <div className="profile_add_button form-button-title">{title}</div>
                        <div className="col-lg-10 offset-lg-1">
                            {(drivingLicences && drivingLicences.length > 0) &&
                                (
                                    <Combo
                                        placeholder="Тип на возачка дозвола"
                                        tooltipText="Одберете тип на возачка дозвола "
                                        comboClass="combo-form"
                                        onChange={(e) => {
                                            let chosenDrivingLicence = {};
                                            chosenDrivingLicence.id = e.target.value;
                                            setEntity({ ...entity, drivingLicence: chosenDrivingLicence })
                                            setShowError(false)
                                        }}
                                        onClear={() => setEntity({...entity, drivingLicence:null})}
                                        array={drivingLicences}/>)}

                            {showError && <b>Ве молиме одберете тип на возачка дозвола</b>}
                        </div>

                        <div className="col-lg-10 offset-lg-1 d-flex justify-content-between">
                            <div
                                className="btn-form"
                                onClick={()=>
                                {setAddEntity(false)
                                    setEntityTemp({candidate: entity.candidate})
                                }}
                            >Затвори</div>
                            <div
                                className="btn-form"
                                onClick={(e) => {
                                    if(entity.drivingLicence && entity.drivingLicence.id !== "0") {
                                        updateResource('candidate_driving_license', entity)
                                            .then((data) => {
                                                console.log(data.data)
                                                setAddEntity(false)
                                                setEntityTemp({candidate: entity.candidate})
                                                setUpdateEntity(!updateEntity)
                                                setShowError(false)
                                            })
                                    } else {
                                        setShowError(true)
                                    }
                                }}
                            >Зачувај</div>
                        </div>
            </>
            )
                }
        </div>
    )
}